import { c as n } from "../vendor.js";
const e = {
  cnx: {
    primary: {
      100: "#EEEBFF",
      200: "#CDC5FF",
      300: "#1900AF",
      400: "#13007D",
      500: "#0A0A32"
    },
    secondary: {
      100: "#FFEBEC",
      200: "#FFB0B5",
      300: "#FF646E",
      400: "#803237",
      500: "#4F1F22"
    },
    tertiary: {
      100: "#FCE1EB",
      200: "#FFBEE6",
      300: "#FF78AA",
      400: "#803C55",
      500: "#592A3B"
    }
  },
  pv: {
    primary: {
      100: "#DDD7EE",
      200: "#D596FF",
      300: "#A04FC9",
      400: "#7C23A8",
      500: "#4A245C"
    },
    secondary: {
      100: "#EEEBFF",
      200: "#CDC5FF",
      300: "#1900AF",
      400: "#13007D",
      500: "#0A0A32"
    },
    tertiary: {
      100: "#F2EFFF",
      200: "#C5B0FF",
      300: "#8053FF",
      400: "#6843CC",
      500: "#412A80"
    }
  }
}, a = {
  feedback: {
    success: {
      100: "#ECFFEB",
      200: "#CBFFC8",
      300: "#1CA44E",
      400: "#17833F",
      500: "#105C2C"
    },
    error: {
      100: "#FFE8E9",
      200: "#FF979A",
      300: "#C8191E",
      400: "#911216",
      500: "#590B0D"
    },
    warning: {
      100: "#FFF9E8",
      200: "#FEE18C",
      300: "#EDB410",
      400: "#8F6C05",
      500: "#594303"
    },
    information: {
      100: "#E2EBF9",
      200: "#93B7F2",
      300: "#1764E3",
      400: "#1353BD",
      500: "#0C3272"
    }
  },
  neutral: {
    100: "#E6E6F0",
    200: "#9292A9",
    300: "#555567",
    400: "#42424F",
    500: "#27272E"
  },
  background: {
    gray: "#FAFAFC",
    white: "#FFFFFF"
  }
}, s = {
  brand: { ...e.cnx },
  ...a
}, f = {
  none: "0px",
  xxs: "1px",
  xs: "4px",
  md: "6px",
  lg: "8px",
  xl: "16px",
  full: "99999px"
}, r = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  radius: f
}, Symbol.toStringTag, { value: "Module" })), i = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px",
  "2xl": "1536px"
}, l = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  breakpoint: i
}, Symbol.toStringTag, { value: "Module" })), m = {
  border: "0px 0px 1px 0px rgba(0, 0, 0, 0.1)",
  level1: "0px 2px 6px 0px rgba(0, 0, 0, 0.1)",
  level2: "6px 6px 12px 0px rgba(0, 0, 0, 0.1)",
  level3: "0px 12px 18px 0px rgba(0, 0, 0, 0.1)",
  level4: "0px 10px 24px 0px rgba(0, 0, 0, 0.1)"
}, p = {
  /**
   * @xxs value in pixels: 8px
   */
  xxs: "0.5rem",
  /**
   * @xs value in pixels: 16px
   */
  xs: "1rem",
  /**
  * @sm value in pixels: 24px
  */
  sm: "1.5rem",
  /**
  * @md value in pixels: 32px
  */
  md: "2rem",
  /**
  * @lg value in pixels: 48px
  */
  lg: "3rem",
  /**
  * @xl value in pixels: 64px
  */
  xl: "4rem",
  /**
  * @2xl rem in pixels: 80px
  */
  "2xl": "5rem"
}, S = {
  microCopy: {
    fontFamily: "'Source Sans 3', sans-serif",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "16px",
    textDecoration: "none"
  },
  linkUnderline: {
    fontFamily: "'Source Sans 3', sans-serif",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "24px",
    textDecoration: "underline"
  },
  link: {
    fontFamily: "'Source Sans 3', sans-serif",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "24px",
    textDecoration: "none"
  },
  label: {
    fontFamily: "'Source Sans 3', sans-serif",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "24px",
    textDecoration: "none"
  },
  button: {
    fontFamily: "'Source Sans 3', sans-serif",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    textDecoration: "none"
  },
  paragraphSmall: {
    fontFamily: "'Source Sans 3', sans-serif",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "24px",
    textDecoration: "none"
  },
  paragraphLarge: {
    fontFamily: "'Source Sans 3', sans-serif",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    textDecoration: "none"
  },
  subheading: {
    fontFamily: "'Source Sans 3', sans-serif",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "24px",
    textDecoration: "none"
  },
  headingSmall: {
    fontFamily: "'Source Sans 3', sans-serif",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "18px",
    lineHeight: "24px"
  },
  headingMedium: {
    fontFamily: "'Source Sans 3', sans-serif",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "20px",
    lineHeight: "32px",
    textDecoration: "none"
  },
  headingLarge: {
    fontFamily: "'Source Sans 3', sans-serif",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "24px",
    lineHeight: "32px",
    textDecoration: "none"
  },
  headingXLarge: {
    fontFamily: "'Source Sans 3', sans-serif",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "32px",
    lineHeight: "48px",
    textDecoration: "none"
  },
  headingXXLarge: {
    fontFamily: "'Source Sans 3', sans-serif",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "40px",
    lineHeight: "48px",
    textDecoration: "none"
  },
  headingDisplay: {
    fontFamily: "'Source Sans 3', sans-serif",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "48px",
    lineHeight: "64px",
    textDecoration: "none"
  }
}, x = {
  /**
   * @xxs value in pixels: 10px
  */
  xxs: "0.625rem",
  /**
   * @xs value in pixels: 12px
  */
  xs: "0.75rem",
  /**
   * @sm value in pixels: 14px
  */
  sm: "0.875rem",
  /**
   * @md value in pixels: 16px
  */
  md: "1rem",
  /**
   * @lg value in pixels: 18px
  */
  lg: "1.125rem",
  /**
   * @xl value in pixels: 20px
  */
  xl: "1.25rem",
  /**
   * @2xl value in pixels: 24px
  */
  "2xl": "1.5rem",
  /**
   * @4xl value in pixels: 32px
  */
  "4xl": "2rem",
  /**
   * @5xl value in pixels: 36px
  */
  "5xl": "2.25rem",
  /**
   * @6xl value in pixels: 48px
  */
  "6xl": "3rem",
  /**
   * @7xl value in pixels: 64px
  */
  "7xl": "4rem",
  /**
   * @8xl value in pixels: 72px
  */
  "8xl": "4.5rem",
  /**
   * @9xl value in pixels: 96px
  */
  "9xl": "6rem"
}, F = {
  light: "300",
  normal: "400",
  medium: "500",
  bold: "600",
  extraBold: "700",
  black: "900"
}, c = [
  {
    fontFamily: "Source Sans 3",
    webFont: {
      url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/SourceSans3-Black.ttf",
      format: "ttf"
    },
    fontWeight: 900,
    fontDisplay: "swap"
  },
  {
    fontFamily: "Source Sans 3",
    webFont: {
      url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/SourceSans3-Black.ttf.woff2",
      format: "woff2"
    },
    fontWeight: 900,
    fontDisplay: "swap"
  },
  {
    fontFamily: "Source Sans 3",
    webFont: {
      url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/SourceSans3-Bold.ttf",
      format: "ttf"
    },
    fontWeight: 700,
    fontDisplay: "swap"
  },
  {
    fontFamily: "Source Sans 3",
    webFont: {
      url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/SourceSans3-Bold.ttf.woff2",
      format: "woff2"
    },
    fontWeight: 700,
    fontDisplay: "swap"
  },
  {
    fontFamily: "Source Sans 3",
    webFont: {
      url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/SourceSans3-SemiBold.ttf",
      format: "ttf"
    },
    fontWeight: 600,
    fontDisplay: "swap"
  },
  {
    fontFamily: "Source Sans 3",
    webFont: {
      url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/SourceSans3-Semibold.ttf.woff2",
      format: "woff2"
    },
    fontWeight: 600,
    fontDisplay: "swap"
  },
  {
    fontFamily: "Source Sans 3",
    webFont: {
      url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/SourceSans3-Medium.ttf",
      format: "ttf"
    },
    fontWeight: 500,
    fontDisplay: "swap"
  },
  {
    fontFamily: "Source Sans 3",
    webFont: {
      url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/SourceSans3-Medium.ttf.woff2",
      format: "woff2"
    },
    fontWeight: 500,
    fontDisplay: "swap"
  },
  {
    fontFamily: "Source Sans 3",
    webFont: {
      url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/SourceSans3-Regular.ttf",
      format: "ttf"
    },
    fontWeight: 400,
    fontDisplay: "swap"
  },
  {
    fontFamily: "Source Sans 3",
    webFont: {
      url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/SourceSans3-Regular.ttf.woff2",
      format: "woff2"
    },
    fontWeight: 400,
    fontDisplay: "swap"
  },
  {
    fontFamily: "Source Sans 3",
    webFont: {
      url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/SourceSans3-Light.ttf",
      format: "ttf"
    },
    fontWeight: 300,
    fontDisplay: "swap"
  },
  {
    fontFamily: "Source Sans 3",
    webFont: {
      url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/SourceSans3-Light.ttf.woff2",
      format: "woff2"
    },
    fontWeight: 300,
    fontDisplay: "swap"
  }
], g = {
  colors: s,
  border: r,
  grid: l,
  shadow: m,
  spacing: p,
  typography: S,
  fontSizes: x,
  fontWeights: F,
  fonts: c
}, u = n((t) => ({
  theme: g,
  setTheme: (o) => t(() => ({ theme: o }))
}));
export {
  u
};
//# sourceMappingURL=theme-store.ts.js.map
